import React from 'react';
import { Col, Row } from 'reactstrap';
import { withStyles } from '@material-ui/core';
import * as Constants from '../Pages/Constants';
import GatewayList from '../Components/Gateway/GatewayList.js';
import {FormattedMessage} from 'react-intl';


const GatewayManagementMenu = (props) => {
  	const { classes } = props;

  	/**Component generating four tabs*/
  	return (
        <div className={classes.popup_background}>
            <div style={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "center"}}>
                <div className="management-menu-popup" style={{ display: "flex", flexDirection: "column" }}>
                    <Row className="justify-content-md-end" style={{ flexShrink: 0, paddingBottom: "12px" }}>
                    	<Col style={{ fontWeight: "bold", fontSize: "clamp(1.25em, 4.5vw, 2.2em)" }}>
                    		<center>
                    		  	<FormattedMessage id="home.gateway" defaultMessage="Gateway" /> - {props.struct_info.struct_name}
                    		</center>
                    	</Col>
                    </Row>
                    <Row style={{ overflowY: "auto", flex: 1, minHeight: 0 }}>
                        <GatewayList 
                            cancelPopup={props.cancelPopup} 
                            closeAfterAdd={props.closeAfterAdd} 
                            role={props.role} 
                            structure_Id={props.structure_Id} 
                            reloadUserAndProfiles={props.reloadUserAndProfiles}
                            accountInformation={props.accountInformation} 
                            subscription_info={props.subscription_info}
                            struct_info={props.struct_info}
                            gateway_list={props.gateway_list}
                            setGatewayList={props.setGatewayList}
                        />
                    </Row>
                    <Row>
                        <center>
                            <button onClick={props.cancelPopup} className="btn btn-danger">
                                <FormattedMessage id="button.close" defaultMessage="Close" />                                           
                            </button>
                        </center>
                    </Row>
                </div>
            </div>
    	</div>
    );
};
export default withStyles(Constants.styles)(GatewayManagementMenu);